import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance

import { jwtDecode } from 'jwt-decode';

function getAuthHeaders() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  return {
    Authorization: `${tokenType} ${token}`,
  };
}


export async function searchUserApi(q) {
  const response = await axiosInstance.get("/users/fetch/some", {
    params: { q }, // query string
  });

  return response.data;
}

export async function allUsersApi() {
  const response = await axiosInstance.get("/users/fetch/all");
  return response.data;
}






export async function fetchSelectedUserFriend(user_id) {
  const response = await axiosInstance.get(`/users/friends/fetch/${user_id}`);

  return response.data;
}


//http://localhost:8000/api/users/friends/status?status=pending&type=incoming


export async function updateRequestStatus(requesterId, status) {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.patch(`/users/friends/${requesterId}`,
      { status }, // request body
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    throw error;
  }
}





export async function fetchFriends() {
  const response = await axiosInstance.get("/users/friends/me");
  return response.data;
}





export async function fetchPending() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get("/users/friends/status/pending", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}



// ✅ Accept friend request
export async function approvePendingRequest(requesterId) {
  try {
    const response = await axiosInstance.patch(
      `/users/friends/${requesterId}`,
      { status: "accepted" },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    handleFriendError(error);
  }
}

// ❌ Reject friend request
export async function rejectPendingRequest(requesterId) {
  try {
    const response = await axiosInstance.patch(
      `/users/friends/${requesterId}`,
      { status: "rejected" },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    handleFriendError(error);
  }
}

// 🔧 Error handler
function handleFriendError(error) {
  if (error.response?.status === 401) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("tokenType");
    throw new Error("Unauthorized. Authentication Expired");
  } else if (error.response?.status === 404) {
    throw new Error("Friend request not found");
  } else if (error.response?.status === 403) {
    throw new Error("Forbidden. Only the receiver can respond.");
  }

  throw error;
}









// ./messages/auth.js


export function getCurrentUserIdFromToken() {
  const token = localStorage.getItem('authToken');
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.sub || decoded.user_id || null;
  } catch (err) {
    console.error('Invalid token:', err);
    return null;
  }
}



export async function fetchChatList() {
  const res = await axiosInstance.get('/messages/chatlist');
  return res.data;

}



export async function fetchMessagesWith(userId, page = 1) {
  const res = await axiosInstance.get(`/messages/users/${userId}`, {
    params: { page } // send the page number
  });

  return res.data; // { messages: [...], total_pages: X, current_page: Y }
}


export async function sendMessage(receiverId, content) {


  const res = await axiosInstance.post('/messages/', {
    receiver_id: receiverId,
    content: content,
  });

  console.log(res.data)

  return res.data;

}


export async function sendAppointment(payload) {
 if (payload.target_id == null) {
  alert(
    "cannot proceed, you must initiate a conversation before creating appointment. and after you must reload the browser for stability"
  );
  return;
}


  const res = await axiosInstance.post('/appointments/conversation', payload);
  return res.data;
}
export async function sendAppointmentInMatchChat(payload) {

    console.log(JSON.stringify(payload));
 
  const res = await axiosInstance.post('/appointments/in_match_chat', payload);
  return res.data;

}


export async function updateInMatchchatGroupName(group_name, group_id) {


  const res = await axiosInstance.patch(`/match/in_match_chat/${group_id}`, group_name);

  return res.data;
}



export async function fetchConversationAppointment(conversation_id) {

  const res = await axiosInstance.get(`/appointments/conversations/${conversation_id}`);
  return res.data;

}


export async function fetchChatGroupList() {

  const res = await axiosInstance.get(`/messages/in_match_chat_list`);
  return res.data

}



export async function fetchGroupMessagesContent(group_id, page) {


  const response = await axiosInstance.get(`/match/in_match_chat/${group_id}`, {
    params: { page } // send the page as query param
  });
  return response.data;
}











export async function fetchGroupAppointment(in_match_id) {


  try {


    const res = await axiosInstance.get(`/appointments/in_match_chat/${in_match_id}`);
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication expired.');
    }

    throw new Error('Failed to fetch conversation appointments');
  }
}







export async function fetchUserScoreBoard(user_id) {

  const res = await axiosInstance.get(`/users/friends/me/scoreboard/${user_id}`);
  return res.data;

}